'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".IconExpand-module_iconExpand__IdQXp{height:auto;width:1rem}";
var styles = {"iconExpand":"IconExpand-module_iconExpand__IdQXp"};
styleInject["default"](css_248z, '14f7894c-e0e5-4791-872a-95dbf143769f');

exports["default"] = styles;
